import classes from "./techPovCard.module.css";
import owner from "../../assets/images/techIcons/user.png";
import time from "../../assets/images/techIcons/clock.png";

const PostCard = (props) => {
  return (
    <>
      <div className={classes.TechPovCardContainer}>
        <div className={classes.imageTechPov}>
          <img src={props.techImage} alt={props.headingTech} />
        </div>
        <div className={classes.TechContent}>
          <div className={classes.dateTimeTech}>
            <div className={classes.PostOwner}>
              <img src={owner} alt="Post owner" />
              {props.techOwner}
            </div>
            <div className={classes.DateTech}>
              <img src={time} alt="Post time" />
              {props.techDate}
            </div>
          </div>
          <div className={classes.ContentTechPov}>
            <p className={classes.HeadingTechPov}>{props.headingTech}</p>
            <p className={classes.descriptionTechPov}>
              {props.descriptionTech}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PostCard;
